/* tslint:disable */

import {LinkageService} from './tatta-user';

export enum RaceType {
  NormalRace = 0, // 通常大会 (自動/手動入力は問わない)
  VirtualRace = 1, // バーチャル大会 (CMSから入力したもの) -> V2.0からはイベントと呼ぶようになった
}

export enum RaceEventType {
  NotRunnetEventType = 0, // データ上0だがrailsコードが見当たらず
  Running = 1,
  Trail = 100011,
  Bike = 3,
  Other = 6
}

export enum RaceRankingMethod {
  RankingByDistance = 0, // 距離ランキング
  RankingByTime = 1,  // タイムアタックランキング
  RankingByGroupDistance = 2, // 距離ランキング（団体戦）
  RankingByDistanceChallenge = 3, // 距離達成チャレンジ（誰でもフルマラソン）
  RankingByArea = 4, // ルート開拓ランキング
  RankingByCalorieChallenge = 5, // カロリー消費チャレンジ
  RankingBySeriesEvent = 6, // シリーズイベント
  // 7 はバックエンドの Nothing（オンラインイベントを行わない・モシコム表示専用の現役値）に予約済みのため admin では欠番。再利用禁止。
  RankingByActivityDays = 8, // 日数チャレンジ
  RankingByMissionBingo = 9, // ミッションビンゴ
  // RankingByElevation, // 標高ランキング
  // RankingByElevationChallenge, // 標高達成チャレンジ
  // RankingByTattaRace, // TATTA RACE スタート時刻指定タイプ
  // RankingByFromHome,  // TATTA RACE スタート時刻・フィニッシュ地点指定タイプ（家からRUN）
}

export const getRaceRankingMethodName = (raceRankingMethod: RaceRankingMethod): string => {
  switch (raceRankingMethod) {
    case RaceRankingMethod.RankingByDistance:
      return '距離ランキング';
    case RaceRankingMethod.RankingByTime:
      return 'タイムアタックランキング';
    case RaceRankingMethod.RankingByGroupDistance:
      return '距離ランキング（団体戦）';
    case RaceRankingMethod.RankingByDistanceChallenge:
      return '距離達成チャレンジ';
    case RaceRankingMethod.RankingByArea:
      return 'ルート開拓ランキング';
    case RaceRankingMethod.RankingByCalorieChallenge:
      return 'カロリー消費チャレンジ';
    case RaceRankingMethod.RankingBySeriesEvent:
      return 'シリーズイベント';
    case RaceRankingMethod.RankingByActivityDays:
      return '日数チャレンジ';
    case RaceRankingMethod.RankingByMissionBingo:
      return 'ミッションビンゴ';
    // case RaceRankingMethod.RankingByFromHome:
    //   return 'TATTA RACE（スタート時刻・フィニッシュ地点指定タイプ）';
    // case RaceRankingMethod.RankingByTattaRace:
    //   return 'TATTA RACE（スタート時刻指定タイプ）';
    // case RaceRankingMethod.RankingByElevation:
    //   return '標高ランキング';
    // case RaceRankingMethod.RankingByElevationChallenge:
    //   return '標高達成チャレンジ';
  }
  return '';
};

export enum RaceRankingElevationType {
  NONE = 0,
  OVER = 1,
  WITHIN = 2,
}

export namespace RaceField {
  export type id = number;
  export type title = string;
  export type location = string | null;
  export type beginning_ranking_term = number | null;
  export type end_of_ranking_term = number | null;
  export type beginning_open_date = number | null;
  export type end_of_open_date = number | null;
  export type created_at = number;
  export type updated_at = number;
  export type event_type = RaceEventType;
  export type is_user_generated = boolean;
  export type detail_url = string | null;
  export type runnet_race_id = number | null;
  export type runnet_total_race_code = string | null;
  export type is_representation = boolean | undefined;
  export type runnet_runtes_id = number | null;
  export type ranking_term_modified_at = number | null; // conv
  export type runnet_json = string | null;
  export type race_type = RaceType;
  export type is_published = boolean;
  export type virtual_race_modified_at = number | null; // conv
  export type ranking_by_running = boolean;
  export type ranking_by_trail_running = boolean;
  export type ranking_by_cycling = boolean;
  export type ranking_by_walking = boolean;
  export type ranking_by_hiking = boolean;
  export type ranking_target_min_pace = number | undefined; // 集計対象となるアクティビティの最低ペース
  export type moshicom_race_id = number | null;
  export type moshicom = boolean;
  export type subtitle = string | null;
  export type beginning_entry_term = number | null;
  export type end_of_entry_term = number | null;
  export type event_outline = string | null;
  export type join_event_image_width = number | null;
  export type join_event_image_height = number | null;
  export type event_description = string | null;
  export type event_rule = string | null;
  export type event_prizes_json = string | undefined;
  export type event_image_width = number | null;
  export type event_image_height = number | null;
  export type ranking_method = RaceRankingMethod | null;
  export type ranking_user_count = number | undefined;
  export type join_event_image_id = string | null;
  export type join_event_image_filename = string | null;
  export type join_event_image_content_size = number | null; // conv
  export type join_event_image_content_type = string | null;
  export type event_image_id = string | null;
  export type event_image_filename = string | null;
  export type event_image_content_size = number | null; // conv
  export type event_image_content_type = string | null;
  export type to_race_id = number | undefined; // 大会にてuser_raceのimport時、合わせてエントリー対象として記録するイベントのraceId
  export type from_runnet_total_race_code = string | undefined; // イベントにて設定するエントリー取り込み元のRUNTES totalRaceId
  export type from_moshicom_race_id = number | undefined; // イベントにて設定するエントリー取り込み元のmoshicom id
}

export interface Race {
  id: RaceField.id;
  title: RaceField.title;
  location?: RaceField.location;
  beginning_ranking_term?: RaceField.beginning_ranking_term;
  end_of_ranking_term?: RaceField.end_of_ranking_term;
  beginning_open_date?: RaceField.beginning_open_date;
  end_of_open_date?: RaceField.end_of_open_date;
  created_at: RaceField.created_at;
  updated_at: RaceField.updated_at;
  event_type: RaceField.event_type;
  is_user_generated: RaceField.is_user_generated;
  detail_url?: RaceField.detail_url;
  runnet_race_id?: RaceField.runnet_race_id;
  runnet_total_race_code?: RaceField.runnet_total_race_code;
  is_representation?: RaceField.is_representation;
  runnet_runtes_id?: RaceField.runnet_runtes_id;
  ranking_term_modified_at?: RaceField.ranking_term_modified_at;
  runnet_json?: RaceField.runnet_json;
  race_type: RaceField.race_type;
  is_published: RaceField.is_published;
  virtual_race_modified_at?: RaceField.virtual_race_modified_at;
  ranking_by_running: RaceField.ranking_by_running;
  ranking_by_trail_running: RaceField.ranking_by_trail_running;
  ranking_by_cycling: RaceField.ranking_by_cycling;
  ranking_by_walking: RaceField.ranking_by_walking;
  ranking_by_hiking: RaceField.ranking_by_hiking;
  ranking_target_min_pace?: RaceField.ranking_target_min_pace;
  moshicom_race_id?: RaceField.moshicom_race_id;
  moshicom: RaceField.moshicom;
  subtitle?: RaceField.subtitle;
  beginning_entry_term?: RaceField.beginning_entry_term;
  end_of_entry_term?: RaceField.end_of_entry_term;
  event_outline?: RaceField.event_outline;
  join_event_image_width?: RaceField.join_event_image_width;
  join_event_image_height?: RaceField.join_event_image_height;
  event_description?: RaceField.event_description;
  event_rule?: RaceField.event_rule;
  event_prizes_json?: RaceField.event_prizes_json;
  event_image_width?: RaceField.event_image_width;
  event_image_height?: RaceField.event_image_height;
  ranking_method?: RaceField.ranking_method;
  ranking_user_count?: RaceField.ranking_user_count;
  join_event_image_id?: RaceField.join_event_image_id;
  join_event_image_filename?: RaceField.join_event_image_filename;
  join_event_image_content_size?: RaceField.join_event_image_content_size;
  join_event_image_content_type?: RaceField.join_event_image_content_type;
  event_image_id?: RaceField.event_image_id;
  event_image_filename?: RaceField.event_image_filename;
  event_image_content_size?: RaceField.event_image_content_size;
  event_image_content_type?: RaceField.event_image_content_type;
  to_race_id?: RaceField.to_race_id;
  from_runnet_total_race_code?: RaceField.from_runnet_total_race_code;
  from_moshicom_race_id?: RaceField.from_moshicom_race_id;
  required_services?: LinkageService[]; // 参加時に連携が必要なサービス（複数ある場合はor条件）
}

export interface Prize {
  title: string;
  text: string;
  imageUrl?: string;
}
